import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_mst_entity_audit_trail_RowClass} from '../../../dbschema';

export class EntityAuditTrailContainerModel extends BaseContainerModel {
  bl_fi_mst_entity_audit_trail: bl_fi_mst_entity_audit_trail_RowClass = new bl_fi_mst_entity_audit_trail_RowClass();
}
